import React from "react"
import ModalContainer from "../ModalContainer"

const ErrorPopup = ({ handleSuccess, content, handleClose }) => {
  return (
    <ModalContainer>
      <div className="bg-white rounded-lg h-80 w-80 p-10">
        <img
          src={require("../../../assets/error.svg").default}
          alt="symbol"
          className="w-28 mx-auto -mt-24"
        />

        <h3 className="mt-16 text-center text-xl font-medium">{content}</h3>

        <div className="flex mt-16 justify-between w-full">
          <div className="text-lg cursor-pointer" onClick={handleClose}>
            Cancel
          </div>
          <div className="text-lg cursor-pointer" onClick={handleSuccess}>
            Yes
          </div>
        </div>
      </div>
    </ModalContainer>
  )
}

export default ErrorPopup
